import React, { memo } from 'react';
import { string, oneOf, func, bool } from 'prop-types';

import { ReactComponent as Spinner } from 'assets/icons/spinner.svg';

const Button = ({
  type,
  testId,
  title,
  className,
  onClick,
  isDisabled,
  showSpinner,
  titleHidden = showSpinner,
  ...rest
}) => {
  return (
    <button
      {...rest}
      data-testid={testId}
      type={type}
      className={`btn ${className}`}
      onClick={type === 'button' ? onClick : undefined}
      disabled={isDisabled || showSpinner}
    >
      <span className="flex relative items-center justify-center w-full">
        {showSpinner && (
          <Spinner className="animate-spin h-6 w-5 fill-current flex-shrink-0 text-white whitespace-nowrap" />
        )}
        <p
          className={`${titleHidden ? 'hidden' : 'block'} ${
            showSpinner ? 'ml-1' : 'ml-0'
          }`}
        >
          {title}
        </p>
      </span>
    </button>
  );
};

Button.propTypes = {
  type: oneOf(['button', 'submit']),
  testId: string,
  title: string,
  className: string,
  onClick: func,
  isDisabled: bool,
  showSpinner: bool,
  titleHidden: bool,
};
Button.defaultProps = {
  className: 'btn-blue',
  onClick: undefined,
  testId: 'button',
  type: 'button',
  isDisabled: false,
  showSpinner: false,
  title: 'Submit',
};

export default memo(Button);
